import gql from 'graphql-tag';

export const TenantsListQuery = gql`
	query TenantsListQuery {
		tenants {
			tenant {
				id
				name
			}
		}
	}
`;

export const OrganizationsInBuilding = gql`
	query OrganizationsInBuilding($buildingId: UUID) {
		organizations(buildingId: $buildingId) {
			id
			name
			smallLogoUrl
		}
	}
`;
